import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toastStyles.css';

import Login from './pages/core/Login';
import Home from './pages/core/Home';
import Basket from './pages/todelete/Basket';
import Basket2 from './pages/todelete/Basket2';
import BasketNew from './pages/core/BasketPage';
import CheckoutFlow from './pages/core/CheckoutFlow';
import Order from './pages/Order';
import Paymentsellection from './pages/Paymentsellection';
import Homarequests from './pages/todelete/Homarequests';
import Offerings from './pages/todelete/Offerings';
import Upload from './pages/todelete/Upload';
import DownloadForms from './pages/todelete/DownloadForms';
import Merittransferrequests from './pages/Merittransferrequests';
import Seasonalrequests from './pages/Seasonalrequests';
import RegularPrayerFormLayout from './pages/core/RegularPrayerFormLayout';
import SpecialPrayerFormLayout from './pages/core/SpecialPrayerFormLayout';
import Merittransferregular from './pages/Merittransferregular';
import Disasterprayerrequest from './pages/Disasterprayerrequest';
import Merittransfermemorial from './pages/Merittransfermemorial';
import Newlydeparted from './pages/Newlydeparted';

// Import auth components
import RootRedirect from './components/RootRedirect';
import ProtectedRoute from './components/ProtectedRoute';
import Template from "./pages/Template";
import HomaRequestPage from "./pages/core/HomaRequestPage";
import UploadPage from "./pages/core/UploadPage";
import DownloadPage from "./pages/core/DownloadPage";
import PaymentOfferingPage from "./pages/core/PaymentOfferingPage";
import BasketPage from "./pages/core/BasketPage";
import PdfEditor from './pages/PdfEditor';

// Import browser utilities for cart isolation
import { initializeBrowserId } from './utils/browserUtils';


function App() {
  // Initialize browser ID on app mount for cart isolation
  useEffect(() => {
    initializeBrowserId();
  }, []);
  return (
    <Router>
      <Routes>
        {/* Root Route - Smart redirect based on auth status */}
        <Route path="/" element={<RootRedirect />} />
        
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected Routes - All wrapped with ProtectedRoute */}
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/basket" element={<ProtectedRoute><BasketPage /></ProtectedRoute>} />
        <Route path="/checkout-flow" element={<ProtectedRoute><CheckoutFlow /></ProtectedRoute>} />
        <Route path="/order" element={<ProtectedRoute><Order /></ProtectedRoute>} />
        <Route path="/paymentsellection" element={<ProtectedRoute><Paymentsellection /></ProtectedRoute>} />
        <Route path="/homa-requests" element={<ProtectedRoute><HomaRequestPage /></ProtectedRoute>} />
        <Route path="/merit-requests" element={<ProtectedRoute><HomaRequestPage /></ProtectedRoute>} />
        <Route path="/seasonal-requests" element={<ProtectedRoute><HomaRequestPage /></ProtectedRoute>} />
        <Route path="/offerings" element={<ProtectedRoute><PaymentOfferingPage /></ProtectedRoute>} />
        <Route path="/upload" element={<ProtectedRoute><UploadPage /></ProtectedRoute>} />
        <Route path="/download-forms" element={<ProtectedRoute><DownloadPage /></ProtectedRoute>} />
        <Route path="/merit-transfer-requests" element={<ProtectedRoute><Merittransferrequests /></ProtectedRoute>} />
        <Route path="/seasonalrequests" element={<ProtectedRoute><Seasonalrequests /></ProtectedRoute>} />
        <Route path="/regular" element={<ProtectedRoute><RegularPrayerFormLayout /></ProtectedRoute>} />
        <Route path="/:type" element={<ProtectedRoute><RegularPrayerFormLayout /></ProtectedRoute>} />
        {/* <Route path="/special" element={<ProtectedRoute><SpecialPrayerFormLayout /></ProtectedRoute>} /> */}
        <Route path="/merittransferregular" element={<ProtectedRoute><Merittransferregular /></ProtectedRoute>} />
        <Route path="/disasterprayerrequest" element={<ProtectedRoute><Disasterprayerrequest /></ProtectedRoute>} />
        <Route path="/merittransfermemorial" element={<ProtectedRoute><Merittransfermemorial /></ProtectedRoute>} />
        <Route path="/newlydeparted" element={<ProtectedRoute><Newlydeparted /></ProtectedRoute>} />
        <Route path="/test" element={<ProtectedRoute><DownloadPage /></ProtectedRoute>} />
  <Route path="/pdf-editor" element={<ProtectedRoute><PdfEditor /></ProtectedRoute>} />
      </Routes>
      
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;
